import React from "react";
import Modal from "Utils/Modal";
import * as actions from "Actions";
import { connect } from "react-redux";
import { RemoveCircle } from "Utils/SvgIcons";
import Endpoints from "Api/endpoints";
import ScrollArea from "Utils/react-scrollbar";
import BarcodeReader from 'Components/BarcodeReader/BarcodeReaderComponent';

class SerializedMoveModal extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      selected: [],
      serialNumber: "",
      movingQuantity: "",
      barcodeInput: false,
      lastScannedSerial: null,
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    this.setState({
      [name]: value
    });
  };

  handleSerialNumberReset = () => {
    this.setState({
      serialNumber: ""
    });
  };

  performSearch = event => {
    event && event.preventDefault();
    const { setErrors, product } = this.props;
    const { serialNumber } = this.state;
    const component = this;
    Endpoints.serializedProducts
      .showBySerialNumber(product, serialNumber)
      .then(response => {
        const { selected } = component.state;
        const { serializedProduct } = response.data;
        const foundIndex = selected.findIndex(
          sp => sp.serialNumber === serializedProduct.serialNumber
        );
        if (foundIndex === -1) {
          component.setState({
            selected: [...selected, serializedProduct],
            serialNumber: ""
          });
        } else {
          setErrors("Serial number already added.");
          component.setState({
            serialNumber: ""
          });
        }
      })
      .catch(error => {
        if (error.response) {
          if (error.response.status === 422) {
            setErrors(error.response.data);
          } else if (error.response.status === 404) {
            setErrors("Cannot find the serialized product.");
          } else {
            setErrors("Oops! an unknown error occurred during check in");
          }
        } else {
          setErrors("Oops! an unknown error occurred during check in");
        }
        console.log(error);
      });
  };

  handleSubmit = () => {
    const { selected } = this.state;

    // Validation
    if (selected.length === 0) {
      this.props.setErrorMessage({
        field: "selected",
        text: "You need to select at least one serialized item."
      });
    } else {
      this.props.onMovingIdsSelect(selected);
      this.props.toggle();
    }
  };

  removeItem = serialNumber => {
    const newSelected = this.state.selected.filter(
      s => s.serialNumber !== serialNumber
    );
    this.setState({
      selected: newSelected
    });
  };

  setBarcodeInput = (value) => {
    this.setState({
      barcodeInput: value,
    });
  };

  onBarcodeDetected = (detections) => {
    const scannedValue = detections[0].data;

    this.setState({
      lastScannedSerial: scannedValue,
    });

    this.handleChange({
      target: {
        name: 'serialNumber',
        value: scannedValue,
      },
    });

    this.performSearch();
  };

  render() {
    const { product, open, toggle } = this.props;
    const { serialNumber, selected, barcodeInput } = this.state;

    return (
      <Modal
        open={open}
        toggle={toggle}
        large={true}
        className="serializedModal pickModal"
        title="Move Serialized Items to Another Location"
        actions={[
          <a className="btn" onClick={this.handleSubmit}>
            Move Inventory
          </a>,
          <a className="btn cancel" onClick={toggle}>
            Cancel
          </a>
        ]}
      >
        <div className="form">
          <p>{product.name}</p>
          <div>
            <form className="fullForm" onSubmit={this.performSearch}>
              {barcodeInput && <BarcodeReader onDetected={this.onBarcodeDetected} />}
              <a
                className='barcode-choose-input'
                onClick={() => this.setBarcodeInput(!barcodeInput)}
              >
                {barcodeInput
                  ? 'Hide barcode scanner'
                  : '📷 Scan barcode using camera'}
              </a>
              <input
                type="text"
                name="serialNumber"
                className="barcode"
                onChange={this.handleChange}
                value={serialNumber}
              />
              <input type="submit" value="Scan Item to List" className="btn" />
              <button
                className="btn cancel"
                onClick={this.handleSerialNumberReset}
              >
                Cancel
              </button>
            </form>
            <section>
              <h4>Total</h4>
              <strong>{selected.length}</strong>
              <ScrollArea speed={0.8} horizontal={false}>
                <table className="grid">
                  <thead>
                    <tr>
                      <th>Serial No</th>
                      <th className="actionSm" />
                    </tr>
                  </thead>
                  <tbody>
                    {selected.map((s, index) => (
                      <tr key={index}>
                        <td>{s.serialNumber}</td>
                        <td>
                          <a
                            className="btnLink remove"
                            onClick={() => this.removeItem(s.serialNumber)}
                          >
                            <RemoveCircle />
                          </a>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </ScrollArea>
            </section>
          </div>
        </div>
      </Modal>
    );
  }
}

const mapStateToProps = state => {
  const { rental, loading } = state.rental;
  const { errors } = state.dashboard;
  return { rental, loading, errors };
};

export default connect(mapStateToProps, actions)(SerializedMoveModal);
